import { Component, OnInit, Injector, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { BaseComponent } from "../../base.component";
import {get, find } from 'lodash';
import * as moment from 'moment';

@Component({
selector: 'schedule-panel',
template: `
<ul class="panel-days clearfix" role="tablist">
<li *ngFor="let day of control.attributes.days"
    [ngClass]="{ 'disabled': day.disabled, 'selected': isDateSelected(day.date) }"
    (click)="!day.disabled && onDaySelect(day.date)"
    (keydown)="!day.disabled && onKeySelect($event, day.date)"
    gtm-handler  events="click" type="dataValue" label="Talk With Us Day" value="{{day.date}}" action="ButtonClick"
    role="presentation"
    tabindex="0">
  <span role="tab">
    <span class="uppercase">{{ dateToShortDay(day.date) }},&nbsp;</span>
    <span>{{ dateToShortDate(day.date) }}</span>
  </span>
</li>
</ul>

<ul class="panel-hours" role="tabpanel">
<li *ngFor="let hour of getSelectedHours();">
  <label [class.disabled]="hour.disabled">
    <input type="radio"
           role="radio"
           aria-hidden=true
           [(ngModel)]="value.hour"
           (change)="!hour.disabled && onHourSelect(value.date, hour.title)"
           [disabled]="hour.disabled"
           gtm-handler events="click"
           handlertype="dataValue"
           label="Talk With Us Hour"
           [value]=hour.title action="ButtonClick"
           name = 'radio_group'
           >
    <span class="custom-input"></span>
    <span class="title">{{ hour.title }}</span>
  </label>
</li>
</ul>

`,
styleUrls: ['./schedule-panel.component.scss']
})
export class SchedulepanelComponent extends BaseComponent implements OnInit, AfterViewInit {
    constructor(injector : Injector) {
      super(injector);
    }

    ngOnInit() {}

    ngAfterViewInit() {}

    ngOnDestroy() {}
  
    dateToShortDay(date) {
      return moment().isSame(date, 'day') ? 'today' : moment(date).format('ddd');
    }
    
    dateToShortDate(date) {
      return moment(date).format('M/D');
    }

    isDateSelected(date) {
      const selectedDate = get(this.value, 'date');    
      return date === selectedDate;
    }

    onKeySelect(event, date) {
      if (event.keyCode == 32 || event.keyCode == 13) {
        this.onDaySelect(date);
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    onDaySelect(date) {
      // do nothing if date is already selected
      if (this.isDateSelected(date)) {
        return;
      }

      const name = this.control.name;
      const value = {
        "date": date,
        "hour": null
      };
      this.value = value;
      this.storeService.updateData(name, date, 'popup');
    }

    getSelectedHours() {
      const selectedDate = get(this.value, 'date');
      const matchedDay   = find(this.control.attributes.days, (day) => day.date === selectedDate)
    
      return matchedDay ? matchedDay.hours : [];
    }

    onHourSelect(date, hour) {
      this.setAnswer({
        "date": date,
        "hour": hour
      });
    }
}
